/** 品牌静态资源 */
export const BRAND_LOGO_SRC = '/images/logo-fang.png';

/** 关于我们页顶部背景图 */
export const ABOUT_HERO_IMAGE_SRC = 'https://picsum.photos/seed/poc-about/1920/480';

/** 案例介绍页顶部背景图 */
export const CASES_HERO_IMAGE_SRC = 'https://picsum.photos/seed/poc-cases/1920/480';

/** 产品动态页顶部背景图 */
export const UPDATES_HERO_IMAGE_SRC = 'https://picsum.photos/seed/poc-updates/1920/480';
